const formatValue = (value: number, unit: string, significantDigits?: number) => {
    const memoryValue = new Intl.NumberFormat('en-US', {
        notation: 'standard',
        maximumFractionDigits: 2,
        maximumSignificantDigits: significantDigits,
    }).format(value)

    return `${memoryValue} ${unit}`
}

function memoryConverter(byte: number, factor: number = 1024, significantDigits?: number) {
    const sign = Math.sign(byte)
    const positivByte = Math.abs(byte)
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    if (byte == 0) return `${byte} B`

    const i = Math.floor(Math.log(positivByte) / Math.log(factor))
    const pow = Math.pow(factor, i)
    const value = (positivByte / Math.pow(factor, i)) * sign

    const unit = units[i]

    return formatValue(value, unit, significantDigits)
}
export { memoryConverter }
